import { FC } from "react";
import Skeleton from "react-loading-skeleton";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";
import { useAppContext } from "web/context/app";

import defaultClasses from "./productPrices.scss";

const SkeletonProductPrices: FC<PropsWithClasses> = ({ classes = {} }) => {
  const { isMobile } = useAppContext();

  return (
    <Skeleton
      className={
        isMobile ? classes.mobileProductPrices : classes.desktopProductPrices
      }
    />
  );
};

export default classify<PropsWithClasses>(defaultClasses)(
  SkeletonProductPrices
);
